import React, { useContext } from 'react';

import { ITextArea } from './interface';

import { FailContext } from 'components/Form';
import { Column } from 'components/Layout/Grid';
import { validators } from 'components/Form/validators';
import Text from 'components/Text';

const TextArea: React.FC<ITextArea> = (props) => {
  const { value, name, required, style, minLength, maxLength, isTrimWhiteSpace, stateName, ...rest } = props;
  const fail = useContext(FailContext);

  const isValid = () => {
    if (validators.textAreaOutRangeLength && isTrimWhiteSpace) {
      return validators.textAreaOutRangeLength(value, name, minLength, required, maxLength);
    }

    if (validators.textarea) {
      return validators.textarea(value, name, minLength, required);
    }

    return true;
  };

  const failStyle = () => {
    const className = isTrimWhiteSpace ? "color-danger animated fadeIn mt-3" : "animated fadeIn mt-1 color-danger position-alert";
    return className;
  };

  return (
    <Column className="flex-1">
      <textarea
        {...rest}
        value={value}
        data-statename={stateName}
        minLength={minLength}
        data-istrimwhitespace={isTrimWhiteSpace}
        data-maxlength={maxLength}
        name={name}
        required={required}
        style={{
          ...style,
          border: isValid() && fail ? '2px solid tomato' : '2px solid #bebebe',
          borderRadius: 6,
          padding: '10px 0px 0 10px',
          resize: 'none',
        }}
      />
      {isValid() && fail && (
        <Text size={12} className={failStyle()}>
          {isValid()}
        </Text>
      )}
    </Column>
  );
};

export default TextArea;
